import React, { useState } from "react";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { Calendar, utils } from "react-modern-calendar-datepicker";
import moment from "moment";
import { useTranslation } from "react-i18next";
import "./style.css";

export default ({
  selectDay,
  clearClick,
  specificItemData,
  categoryData,
  renderContinue,
  calenderAvailibility,
}) => {
  let year = moment().format("YYYY");
  let month = moment().format("MM");
  let day = moment().format("DD");
  const { t } = useTranslation();

  const defaultFrom = {
    year: parseInt(year),
    month: parseInt(month),
    day: parseInt(day),
  };

  const [selectedDayRange, setSelectedDayRange] = useState({
    from: defaultFrom,
    to: {},
  });
  const [priceAlert, setPriceAlert] = useState(false);

  function renderSelectDate(value) {
    setSelectedDayRange(value);
  }

  function checkValidation() {
    let from = "";
    let to = "";
    from = `${selectedDayRange.from?.year}-${selectedDayRange.from?.month}-${selectedDayRange.from?.day}`;
    to = `${selectedDayRange.to?.year}-${selectedDayRange.to?.month}-${selectedDayRange.to?.day}`;

    let final = moment(to).diff(from, "day");

    if (!selectDay) {
      alert(t("Select_Any_Bundle"));
    } else if (selectDay == 1 && final > 6 && !priceAlert) {
      alert(t("The_Weekly_Or_Monthly"));
      setPriceAlert(true);
    } else if (selectDay == 2 && final < 7) {
      alert(t("Please_Select_Daily_Plan"));
    } else if (selectDay == 2 && final > 30) {
      alert(t("The_Monthly_Plan_Would"));
      setPriceAlert(true);
    } else if (selectDay == 3 && final < 30) {
      alert(t("Please_Select_Daily_Weekly"));
    } else {
      let payload = {
        item: specificItemData,
        categoryData,
        selectedDayRange,
        days: final ? final : 1,
        selectDay,
      };
      renderContinue(payload);
    }
  }

  return (
    <div className="p-3">
      <Calendar
        value={selectedDayRange}
        minimumDate={utils().getToday()}
        disabledDays={calenderAvailibility}
        onChange={renderSelectDate}
        colorPrimary="#0fbcf9" // added this
        colorPrimaryLight="rgba(75, 207, 250, 0.4)" // and this
        shouldHighlightWeekends
        renderFooter={() => (
          <div className="row pb-1">
            <div
              className="col-lg-6 col-6 p-2"
              onClick={() => clearClick(false)}
            >
              <button
                type="button"
                class="btn-start w-100 btn btn-outline-secondary"
              >
                {t("Clear")}
              </button>
            </div>
            <div className="col-lg-6 col-6 p-2">
              <button
                class="btn-start btn-light w-100"
                onClick={checkValidation}
              >
                {t("Continue")}
              </button>
            </div>
          </div>
        )}
      />
    </div>
  );
};
